import React, { useState } from 'react';
import FeedbackDrawer from './components/FeedbackDrawer';

const BetaBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (!isVisible) return null;

  return (
    <>
    <div className="bg-indigo-50 border-b border-indigo-100 text-indigo-800 px-3 py-2 sm:px-4 sticky top-0 z-[100]">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <span className="bg-indigo-100 text-indigo-700 text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 rounded-full uppercase tracking-wider border border-indigo-200 flex-shrink-0 font-bold">
            Beta
          </span>
          <p className="text-xs sm:text-sm font-medium truncate text-indigo-700">
            We're in early access — your feedback shapes what we build next.
          </p>
        </div>

        <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
          <button
            onClick={() => setDrawerOpen(true)}
            className="text-[10px] sm:text-xs md:text-sm underline underline-offset-2 sm:underline-offset-4 hover:text-indigo-900 transition-colors font-semibold whitespace-nowrap text-indigo-600"
          >
            Share feedback
          </button>
          <button
            onClick={() => setIsVisible(false)}
            className="p-1 hover:bg-indigo-100 rounded-full transition-colors flex-shrink-0 text-indigo-400 hover:text-indigo-600"
            aria-label="Dismiss banner"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-3.5 w-3.5 sm:h-4 sm:w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <FeedbackDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
};

export default BetaBanner;
